import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { RecoProductCardFragmentDoc } from '@packages/gql/generated/shopping/RecoProductCardFragmentDoc';
import type { GlycerinTile } from '@packages/tracking/src/types/types';
import { GlycerinTileType } from '@packages/tracking/src/types/enums';

/**
 * This function is used to retrieve the Glycerin tiles from the recommendations.
 * @param recommendations - The recommendations to filter and map to Glycerin tiles.
 * @param rdeTypeAbbr - The RDE type abbreviation. Is used to find out if tileType is Ad or Product.
 * @returns GlycerinTile[] - An array of GlycerinTile objects.
 */
export const getProductGlycerinTiles = (
  recommendationsData: Array<FragmentType<typeof RecoProductCardFragmentDoc>>,
  rdeTypeAbbr: string,
): GlycerinTile[] => {
  const recommendations = getFragmentData(RecoProductCardFragmentDoc, recommendationsData);

  return recommendations.map((recommendation, index) => {
    const tileType: GlycerinTileType =
      rdeTypeAbbr.startsWith('criteo_') || rdeTypeAbbr.startsWith('mirakl_')
        ? GlycerinTileType.AD
        : GlycerinTileType.PRODUCT;

    const getAdId = () => {
      if (tileType === GlycerinTileType.AD) {
        if (rdeTypeAbbr.startsWith('mirakl_')) {
          return recommendation.tracking.adId ?? 'mirakl';
        }
        return 'criteo';
      }
      return undefined;
    };

    const adId = getAdId();
    const articleId = `${recommendation.product!.orderNumber}${recommendation.product!.promotion}`;
    const productId = recommendation.product!.akl;
    const skuId = recommendation.product!.sku;

    return {
      productId,
      articleId,
      adId,
      tileType,
      listPosition: index + 1,
      skuId,
    };
  });
};
